<div class="card">
  <p-toolbar>
    <div class="p-toolbar-group-start">
      <!-- <app-add-popup></app-add-popup> -->
      <p-button icon="pi pi-plus" class="mr-2" />
      <p-button icon="pi pi-print" class="mr-2" />
      <p-button icon="pi pi-upload" />
    </div>
    <div class="p-toolbar-group-center">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText placeholder="Search" />
      </span>
    </div>
    <div class="p-toolbar-group-end">
      <p-splitButton label="{{ 'button.validate' | transloco }}" icon="pi pi-check" [model]="items" />
    </div>
  </p-toolbar>
</div>
